module.exports = __webpack_public_path__ + "img/Dine-in Icon - white.92285d5e.svg";